<template>
  <section v-html="articleContent"></section>
</template>

<script setup>
const props = defineProps({ blok: Object });
const articleContent = computed(() => renderRichText(props.blok.text));
</script>
